module.exports = __webpack_public_path__ + "static/img/_G9A5959.cf19adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/_G9A5959.jpg
// module id = 2XfR
// module chunks = 0